import { StyleSheet, Text, View } from "react-native";
import React from "react";

const Company = () => {
  return (
    <View>
      <Text>Company</Text>
    </View>
  );
};

export default Company;

const styles = StyleSheet.create({});
